import { render, staticRenderFns } from "./ZoomAvatarComponent.vue?vue&type=template&id=1f9497dd&scoped=true&"
import script from "./ZoomAvatarComponent.vue?vue&type=script&lang=ts&"
export * from "./ZoomAvatarComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ZoomAvatarComponent.vue?vue&type=style&index=0&id=1f9497dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9497dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VImg,VLabel,VProgressCircular,VRow})
